<template>
    <div class="container">
        <div class="columns">
            <div class="column">
                <font-awesome-icon icon="cut" class="fa" />
                <p class="statement">quality haircuts</p>
            </div>
            <div class="column is-hidden-mobile">
                <font-awesome-icon icon="pound-sign" class="fa" />
                <p class="statement">competitive prices</p>
            </div>
            <div class="column is-hidden-mobile">
                <font-awesome-icon icon="parking" class="fa" />
                <p class="statement">free parking</p>
            </div>
        </div>
    </div>
</template>
<script>
    
    export default {
        name: 'benefits'
    }

</script>
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Major+Mono+Display');


    h4 {
        font-family: 'Major Mono Display', monospace;
        ;
        font-weight: 300;
        font-size: 1.5rem;

    }

    .column {
        text-align: center;
    }

    .container {

        margin-top: 25px;
        margin-bottom: 25px;

    }

    .statement {

        margin-top: 10px;

    }

    .fa {

        font-size: 5rem;

    }

</style>
